import React from 'react';
import { Close } from '@mui/icons-material';
import { Card, IconButton, Link, Row, Stack, Text } from 'library/ui';

export function NotificationPreferencesNudge({ onDismiss }: { onDismiss: () => void }) {
    return (
        <Card tone="secondary" padding="sm">
            <Row justify="between" align="start" gap="md">
                <Stack gap="sm">
                    <Stack gap="none">
                        <Text weight="semibold">Set Your Notification Preferences</Text>
                        <Text size="sm" tone="secondary">
                            Choose which updates you get by email or text, and when texts can be sent.
                        </Text>
                    </Stack>
                    <Link to="/profile" size="sm" underline={false}>
                        Set Preferences →
                    </Link>
                </Stack>
                <IconButton icon={Close} onClick={onDismiss} tooltip="Dismiss" size={28} iconSize={16} />
            </Row>
        </Card>
    );
}
